import { render } from "./ScrollytellingDragger.vue?vue&type=template&id=03759d78"
import script from "./ScrollytellingDragger.vue?vue&type=script&lang=js"
export * from "./ScrollytellingDragger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__